var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25c.41 0 .75.34.75.75v1.25H14A4.75 4.75 0 0118.75 8a.75.75 0 01-1.5 0c0-1.8-1.46-3.25-3.25-3.25h-1.25v6.7l3.1 1.04a4.24 4.24 0 01-1.34 8.26h-1.76V22a.75.75 0 01-1.5 0v-1.25H10A4.75 4.75 0 015.25 16a.75.75 0 011.5 0c0 1.8 1.46 3.25 3.25 3.25h1.25v-6.7l-3.1-1.04a4.24 4.24 0 011.34-8.26h1.76V2c0-.41.34-.75.75-.75zm-.75 3.5H9.49a2.74 2.74 0 00-.87 5.33l2.63.88V4.75zm1.5 8.3v6.2h1.76a2.74 2.74 0 00.87-5.33l-2.63-.88z"
  })));
}
export default SvgDollarSign;